import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-password-dialog',
    templateUrl: './password-dialog.component.html',
    styleUrls: ['./password-dialog.component.scss'],
    standalone: false
})
export class PasswordDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    if (data.confirm === null || data.confirm === undefined) {
      data.confirm = "Ok";
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
